import { DevicesRouterStoreSelectors } from '../router';
import { selectAllNotes } from './notes.reducer';
import { NotesState } from './notes.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectNotesState = createFeatureSelector<NotesState>('notes');

export const selectNotes = createSelector(selectNotesState, selectAllNotes);

export const selectNotesForCurrentUdid = createSelector(
  selectNotes,
  DevicesRouterStoreSelectors.selectUdid,
  (notes, udid) => notes.filter((x) => x.udid === udid)
);
